import { call, put, select, takeEvery } from "redux-saga/effects";
import { setAuthorization } from "../../../helpers/api_helper";
import { fetchFormData, postLogin } from "../../../helpers/backend_helper";
import {
  GET_ALL_FORMS,
  LOGIN_USER,
  LOGOUT_USER,
  SET_NEWPASSWORD,
} from "./actionTypes";
import {
  apiError,
  loginSuccess,
  logoutUserSuccess,
  newPasswordRequired,
  newPasswordSessionId,
} from "./actions";
import { getAllUSer } from "../../common/actions";
import OneSignal from "react-onesignal";

function* fetchForm() {
  try {
    const response = yield call(fetchFormData, {
      act: "common",
      subact: "getAllForms",
      info: {},
    });
    localStorage.setItem("formResponse", JSON.stringify(response.data));
  } catch (error) {
    yield put(apiError(error));
  }
}

function* getAllIncidentType() {
  try {
    const response = yield call(fetchFormData, {
      act: "common",
      subact: "getAllIncidentType",
      info: {},
    });
    localStorage.removeItem("incidentTypes");
    localStorage.setItem("incidentTypes", JSON.stringify(response.data));
  } catch (error) {
    yield put(apiError(error));
  }
}

function* getAllUsers() {
  try {
    const response = yield call(postLogin, {
      act: "user",
      subact: "getAll",
      info: {},
    });
    yield put(getAllUSer(response.data));
    localStorage.setItem("users", JSON.stringify(response.data));
  } catch (error) {
    yield put(apiError(error));
  }
}


function* loginUser({ payload: { user, history } }) {
  try {
    const response = yield call(postLogin, {
      act: "user",
      subact: "login",
      info: {
        username: user.email,
        password: user.password,
      },
    });
    if (response.data.tokens?.ChallengeName === "NEW_PASSWORD_REQUIRED") {
      
    
      yield put(newPasswordRequired(true));
      localStorage.setItem("authUser", JSON.stringify(response.data.user));
      localStorage.setItem("menu", JSON.stringify(response?.data?.menu));

      yield put(newPasswordSessionId(response?.data?.tokens?.Session));
    } else {
     

      localStorage.setItem("tokens", JSON.stringify(response.data.tokens));
      yield put(newPasswordRequired(false));
      setAuthorization(response.data.tokens.AuthenticationResult.AccessToken);
      localStorage.setItem("authUser", JSON.stringify(response.data.user));
      localStorage.setItem("menu", JSON.stringify(response?.data?.menu));

      yield put(loginSuccess(response.data));

      // Fetch and store additional API data
      yield call(getAllUsers);
      yield call(fetchForm);
      yield call(getAllIncidentType);
      
      history("/dashboard");
    }
  } catch (error) {
    yield put(newPasswordRequired(false));
    yield put(apiError(error));
  }
}

function* setNewPassword({ payload: { user, history } }) {
  try {
    const state = yield select(); // This will get the full Redux state
    const sessionId = state.login.newpasswordSessionId;
    if (localStorage.getItem("authUser")) {
      const obj = JSON.parse(localStorage.getItem("authUser"));
      const response = yield call(postLogin, {
        act: "user",
        subact: "setPassword",
        info: {
          username: obj.email,
          newPassword: user,
          session: sessionId,
        },
      });

      localStorage.setItem("tokens", JSON.stringify(response.data.tokens));
      setAuthorization(response.data.tokens.AuthenticationResult.AccessToken);
      localStorage.setItem("authUser", JSON.stringify(response.data.user));
      yield put(loginSuccess(response.data));
      yield call(getAllUsers);
      yield call(fetchForm);
      yield call(getAllIncidentType);
      history("/dashboard");
    }
  } catch (error) {
    yield put(apiError(error));
  }
}

function* logoutUser() {
  try {
    localStorage.removeItem("authUser");
    localStorage.removeItem("formResponse");
    localStorage.removeItem("tokens")
    localStorage.removeItem("menu")

    yield put(logoutUserSuccess(LOGOUT_USER, true));
  } catch (error) {
    yield put(apiError(LOGOUT_USER, error));
  }
}

function* authSaga() {
  yield takeEvery(LOGIN_USER, loginUser);
  yield takeEvery(LOGOUT_USER, logoutUser);
  yield takeEvery(SET_NEWPASSWORD, setNewPassword);
  yield takeEvery(GET_ALL_FORMS, fetchForm);

}

export default authSaga;
